import script from "./CompanySeal.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanySeal.vue?vue&type=script&setup=true&lang=js"

import "./CompanySeal.vue?vue&type=style&index=0&id=38e642e3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38e642e3"]])

export default __exports__